/**
 * Session security configuration aligned with OWASP Session Management
 * and NIST SP 800-63B guidelines.
 *
 * Three tiers based on privilege level:
 * - ADMIN: back-office, djayma admin (high privilege, strict timeouts)
 * - CUSTOMER: djayma storefront, public-facing apps (standard timeouts)
 * - MOBILE: field agents using the mobile app (extended for fieldwork)
 */
export const SESSION_SECURITY = {
  // Admin (back-office, djayma admin) — high privilege
  ADMIN: {
    IDLE_TIMEOUT_MS: 15 * 60 * 1000, // 15 minutes
    ABSOLUTE_TIMEOUT_MS: 8 * 60 * 60 * 1000, // 8 hours
    WARNING_BEFORE_MS: 2 * 60 * 1000, // 2 minutes before
  },
  // Customer (djayma, storefront) — standard
  CUSTOMER: {
    IDLE_TIMEOUT_MS: 30 * 60 * 1000, // 30 minutes
    ABSOLUTE_TIMEOUT_MS: 24 * 60 * 60 * 1000, // 24 hours
    WARNING_BEFORE_MS: 2 * 60 * 1000, // 2 minutes before
  },
  // Mobile field agents — extended for fieldwork conditions
  MOBILE: {
    IDLE_TIMEOUT_MS: 60 * 60 * 1000, // 60 minutes
    ABSOLUTE_TIMEOUT_MS: 12 * 60 * 60 * 1000, // 12 hours
    WARNING_BEFORE_MS: 5 * 60 * 1000, // 5 minutes before
  },
  // Re-validation throttle — max once per 30 seconds
  REVALIDATION_THROTTLE_MS: 30 * 1000,
  // BroadcastChannel name for multi-tab sync
  BROADCAST_CHANNEL: 'cieda-auth-sync',
  // Session storage keys
  STORAGE_KEYS: {
    LOGIN_TIMESTAMP: 'cieda_session_login_ts',
    LAST_ACTIVITY: 'cieda_session_last_activity',
  },
} as const;

export type SessionTier = 'ADMIN' | 'CUSTOMER' | 'MOBILE';

export type SessionTierConfig = (typeof SESSION_SECURITY)[SessionTier];
